var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCopy16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 8 4.028 C 6.901 3.042 5.476 2.498 4 2.5 C 3.299 2.5 2.625 2.62 2 2.841 L 2 12.341 C 2.642 12.115 3.319 11.999 4 12 C 5.537 12 6.939 12.578 8 13.528 M 8 4.028 C 9.099 3.042 10.524 2.498 12 2.5 C 12.701 2.5 13.375 2.62 14 2.841 L 14 12.341 C 13.358 12.115 12.681 11.999 12 12 C 10.524 11.998 9.099 12.542 8 13.528 M 8 4.028 L 8 13.528",
    fill: "transparent",
    strokeWidth: 1.14,
    stroke: "rgb(108, 114, 132)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy16);
export default __webpack_public_path__ + "static/media/ic_copy_16.3167f0e1cfc954261e0d8ec969901f0d.svg";
export { ForwardRef as ReactComponent };